/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VwbSystemNotificationPriority } from './VwbSystemNotificationPriority';
import {
    VwbSystemNotificationPriorityFromJSON,
    VwbSystemNotificationPriorityFromJSONTyped,
    VwbSystemNotificationPriorityToJSON,
} from './VwbSystemNotificationPriority';
import type { VwbSystemNotificationType } from './VwbSystemNotificationType';
import {
    VwbSystemNotificationTypeFromJSON,
    VwbSystemNotificationTypeFromJSONTyped,
    VwbSystemNotificationTypeToJSON,
} from './VwbSystemNotificationType';

/**
 * 
 * @export
 * @interface VwbSystemNotification
 */
export interface VwbSystemNotification {
    /**
     * The notification ID Verily Workbench assigned. Set on responses only
     * @type {string}
     * @memberof VwbSystemNotification
     */
    id?: string;
    /**
     * Title of the banner, e.g. 'Service Incident: December 6, 2019'
     * @type {string}
     * @memberof VwbSystemNotification
     */
    title: string;
    /**
     * The actual message of the banner
     * @type {string}
     * @memberof VwbSystemNotification
     */
    message: string;
    /**
     * 
     * @type {VwbSystemNotificationType}
     * @memberof VwbSystemNotification
     */
    notificationType: VwbSystemNotificationType;
    /**
     * 
     * @type {VwbSystemNotificationPriority}
     * @memberof VwbSystemNotification
     */
    notificationPriority: VwbSystemNotificationPriority;
    /**
     * Start time for when this banner should be shown, in milliseconds since epoch. Null starts immediately.
     * @type {number}
     * @memberof VwbSystemNotification
     */
    startTimeEpochMillis?: number;
    /**
     * End time for when this banner should no longer be shown, in milliseconds since epoch. Null means it never expires.
     * @type {number}
     * @memberof VwbSystemNotification
     */
    endTimeEpochMillis?: number;
}

/**
 * Check if a given object implements the VwbSystemNotification interface.
 */
export function instanceOfVwbSystemNotification(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "notificationType" in value;
    isInstance = isInstance && "notificationPriority" in value;

    return isInstance;
}

export function VwbSystemNotificationFromJSON(json: any): VwbSystemNotification {
    return VwbSystemNotificationFromJSONTyped(json, false);
}

export function VwbSystemNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): VwbSystemNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': json['title'],
        'message': json['message'],
        'notificationType': VwbSystemNotificationTypeFromJSON(json['notificationType']),
        'notificationPriority': VwbSystemNotificationPriorityFromJSON(json['notificationPriority']),
        'startTimeEpochMillis': !exists(json, 'startTimeEpochMillis') ? undefined : json['startTimeEpochMillis'],
        'endTimeEpochMillis': !exists(json, 'endTimeEpochMillis') ? undefined : json['endTimeEpochMillis'],
    };
}

export function VwbSystemNotificationToJSON(value?: VwbSystemNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'message': value.message,
        'notificationType': VwbSystemNotificationTypeToJSON(value.notificationType),
        'notificationPriority': VwbSystemNotificationPriorityToJSON(value.notificationPriority),
        'startTimeEpochMillis': value.startTimeEpochMillis,
        'endTimeEpochMillis': value.endTimeEpochMillis,
    };
}

